<template>
  <div class="newly">
    <div class="form">
      <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="债务人姓名" prop="realname">
          <a-input maxLength="49" v-model="form.realname" :disabled='isEdit("realname")'
            :class='{ "yellow": isEdit("realname") }' />
        </a-form-model-item>
        <a-form-model-item label="债务人类型" prop="type">
          <a-select v-model="form.type" placeholder="请选择" :disabled='isEdit("type")'
            :class='{ "yellow": isEdit("type") }'>
            <a-select-option :value="1">个人</a-select-option>
            <a-select-option :value="2">企业</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="债务人证件号码" prop="chinaid">
          <a-input :maxLength="18" v-model="form.chinaid" :disabled='isEdit("chinaid")'
            :class='{ "yellow": isEdit("chinaid") }' @blur="getSex(form.chinaid)" />
        </a-form-model-item>
        <a-form-model-item label="债务人联系方式" prop="phone">
          <a-input v-model="form.phone" :maxLength="20" :disabled='isEdit("phone")'
            :class='{ "yellow": isEdit("phone") }' />
        </a-form-model-item>
        <a-form-model-item label="债务人性别：" prop="sex">
          <a-select v-model="form.sex" placeholder="请选择" :disabled='isEdit("sex")' :class='{ "yellow": isEdit("sex") }'>
            <a-select-option :value="1">男</a-select-option>
            <a-select-option :value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="业务类型：" prop="car_type_id">
          <a-select v-model="form.car_type_id" placeholder="请选择" :disabled='isEdit("car_type_id")'
            :class='{ "yellow": isEdit("car_type_id") }'>
            <a-select-option :value="0">请选择</a-select-option>
            <a-select-option :value="i.id" v-for='(i, index) in APIKEY.carlist' :key='index'>{{ i.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="原被告身份是否准确：" prop="is_role_exact">
          <a-select v-model="form.is_role_exact" placeholder="请选择" :disabled='isEdit("is_role_exact")'
            :class='{ "yellow": isEdit("is_role_exact") }'>
            <a-select-option :value="1">是</a-select-option>
            <a-select-option :value="2">否</a-select-option>
            <a-select-option :value="3">混合</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="户籍所在地：" prop="citys">
          <a-cascader :options="options" placeholder="请选择" @change="citysCg"
            :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='form.citys'
            :disabled='isEdit("province,city,area")' :class='{ "yellow": isEdit("province,city,area") }' />
          <a-input v-model="form.addr" type='textarea' style="margin-top:20px;" placeholder="请输入债务人详细地址"
            :disabled='isEdit("addr")' :class='{ "yellow": isEdit("addr") }' @blur="AddCg" />
        </a-form-model-item>
        <a-form-model-item label="经常居住地：" prop="dwell">
          <a-cascader :options="options" placeholder="请选择"
            :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='form.dwell'
            :disabled='isEdit("dwell_province,dwell_city,dwell_area")'
            :class='{ "yellow": isEdit("dwell_province,dwell_city,dwell_area") }' />
          <a-input v-model="form.dwell_addr" type='textarea' style="margin-top:20px;" placeholder="经常居住地详细地址"
            :disabled='isEdit("dwell_addr")' :class='{ "yellow": isEdit("dwell_addr") }' />
        </a-form-model-item>
        <a-form-model-item label="是否代偿完毕：" prop="is_full_pay">
          <a-select v-model='form.is_full_pay' :disabled='isEdit("is_full_pay")'
            :class='{ "yellow": isEdit("is_full_pay") }'>
            <a-select-option :key="1">不详</a-select-option>
            <a-select-option :key="2">是</a-select-option>
            <a-select-option :key="3">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item label="是否案件完毕：" prop="cause_is_complete">
          <a-select v-model='form.cause_is_complete' :disabled='isEdit("cause_is_complete")' :class='{"yellow":isEdit("cause_is_complete")}'>
            <a-select-option :key="0">否</a-select-option>
            <a-select-option :key="1">是</a-select-option>
          </a-select>
        </a-form-model-item> -->

        <a-form-model-item label="最后代偿时间：" prop="last_compensation_time">
          <a-date-picker v-model="form.last_compensation_time" placeholder="最后代偿时间" valueFormat="YYYY-MM-DD"
            format='YYYY-MM-DD' type="date" style="width:100%;" :disabled='isEdit("last_compensation_time")'
            :class='{ "yellow": isEdit("last_compensation_time") }' />
          <!-- <a-input v-model="form.comment" type='textarea' placeholder="最后代偿时间" :disabled='isEdit("comment")' :class='{"yellow":isEdit("comment")}' /> -->
        </a-form-model-item>

        <a-form-model-item label='关联原告' prop='accuser_id'>
          <a-select v-model="form.accuser_id" placeholder="请选择" style="width: 100%;"
            v-if='!edit || $store.state.user.id <= 1' :disabled='$store.state.user.id <= 1 && isEdit("accuser_id")'
            :class='{ "yellow": $store.state.user.id <= 1 && isEdit("accuser_id") }'>
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
          <span v-else>{{ accuser.title }}</span>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="width:148px;">
              提交
            </a-button>
          </a-popconfirm>
          <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;"
            @click='$router.back(-1)'>取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import city from "@/assets/js/city.json"
import Validator from "@/assets/js/yz.js"
import { getAccuserAll } from "@/server/api"
import { mapGetters } from 'vuex'
import { citySort } from '@/assets/js/unit'

function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}
export default {
  data() {
    // 自定义验证函数
    const validateChinaId = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入债务人证件号码'));
        return;
      }

      // 身份证验证规则
      const idCardPattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      // 统一社会信用代码验证规则
      const creditCodePattern = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;

      // 检查是否符合身份证格式
      const isIdCard = idCardPattern.test(value);
      // 检查是否符合统一社会信用代码格式
      const isCreditCode = creditCodePattern.test(value);

      // 如果两种格式都不符合，返回错误
      if (!isIdCard && !isCreditCode) {
        callback(new Error('请输入有效的债务人证件号码'));
      } else {
        callback();
      }
    };
    return {
      Validator,
      audit: [],   //在修改中的字段
      options: citySort(city),
      accuserList: [],
      accuser: {},
      rules: {
        //    cause_is_complete: [{ required: true, message: '请选择是否案件完毕', trigger: 'change' }],
        is_full_pay: [{ required: true, message: '请选择是否代偿完毕', trigger: 'change' }],
        realname: [{ required: true, message: '请输入债务人姓名', trigger: 'blur' }],   //
        chinaid: [
          { required: true, trigger: 'blur', message: '请输入债务人证件号码' },
          { validator: validateChinaId, trigger: ['blur', 'change'] }
        ],//
        phone: [{ required: false, validator: Validator.validateContact, trigger: ['blur', 'change'] }],
        sex: [{ required: true, trigger: 'change', message: '请选择债务人性别' }],//
        car_type_id: [{ required: false, trigger: 'change', message: '请选择债车型' }],
        citys: [{ required: false, trigger: 'change', message: '请选择户籍所在地' }],
        type: [{ required: true, trigger: 'change', message: '请选择债务人类型' }],// 
        is_role_exact: [{ required: true, trigger: 'change', message: '请选择' }]
      },
      edit: false,
      form: {
        //    cause_is_complete: 0,
        last_compensation_time: "",
        is_full_pay: 1,
        accuser_id: '',
        is_role_exact: 1,
        chinaid: '',
        dwell_addr: '',
        addr: '',
        dwell: [],
        citys: [],
        sex: 1,
        car_type_id: 0,
      }
    }
  },
  created() {
    this.init(this.$route.query.id)
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
  },
  computed: {
    ...mapGetters([
      'APIKEY'
    ])
  },
  methods: {
    // concat(e){
    //   const concatValue = Validator.validateContact(e.target.value)
    //   console.log('concatValue',concatValue);

    // },
    citysCg(val) {
      if (this.form.dwell.length == 0) {
        this.form.dwell = val
      }
    },
    AddCg(val) {
      if (this.form.dwell_addr.length == 0) {
        this.form.dwell_addr = this.form.addr
      }
    },
    getSex(UUserCard) {
      this.form.sex = parseInt(UUserCard.substr(16, 1)) % 2 == 1 ? 1 : 2
    },
    isEdit(val) {
      let bool = this.audit.filter(ele => {
        return val.split(",").indexOf(ele.field) >= 0
      }).length > 0 ? true : false;
      return bool
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          if (form.citys.length > 0) {
            form.province = form.citys[0];
            form.city = form.citys[1];
            form.area = form.citys[2];
            delete form.citys
          }
          if (form.dwell.length > 0) {
            form.dwell_province = form.dwell[0];
            form.dwell_city = form.dwell[1];
            form.dwell_area = form.dwell[2];
            delete form.dwell
          }

          let id = this.$route.query.id
          if (id) {
            form.id = id
          }
          this.$Ajax({
            url: id ? 'debtor/edit' : 'debtor/add',
            data: form,
            success: (e) => {
              this.$message.success({ content: id ? '修改成功' : '新增成功', key: 'updatable' });
              this.reset()
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      this.$refs.forms.resetFields();
      this.$router.back(-1)
    },
    init(id) {
      this.edit = id ? true : false;
      if (id) {
        this.$Ajax({
          url: 'debtor/info',
          type: 'get',
          data: { id: id },
          success: (res) => {
            let e = res.info;
            this.audit = res.info.audit;
            this.accuser = res.info.accuser || {}
            this.form = {
              accuser_id: e.accuser_id,
              //   cause_is_complete: e.cause_is_complete,
              citys: [e.province, e.city, e.area],
              dwell: e.dwell_province ? [e.dwell_province, e.dwell_city, e.dwell_area] : [e.province, e.city, e.area],
              last_compensation_time: isValidDate(new Date(e.last_compensation_time)) ? e.last_compensation_time : '',
              is_role_exact: e.is_role_exact,
              is_full_pay: e.is_full_pay,
              dwell_addr: e.dwell_addr,
              addr: e.addr,
              type: e.type,
              chinaid: e.chinaid,
              realname: e.realname,
              phone: e.phone,
              sex: e.sex,
              car_type_id: e.car_type_id
            }
          }
        })
      } else {
        this.rules.accuser_id = [{ required: true, trigger: 'change', message: '请选择原告' }]

      }
    }
  }
}
</script>
<style lang="less">
.newly .yellow {
  border: 1px solid #ff9800 !important;
  opacity: 1;
  color: #ccc;
  /* border: 0 none; */
  background: none;
  border-radius: 6px;
}
</style>
<style lang="less" scoped>
.newly {
  .form {
    width: 600px;
    margin: 0 auto;
  }

  background: #fff;
  padding: 60px 26px;
}
</style>